import React from 'react';
import { cn } from '@/lib/cn';
import { SpriteIcon } from '@/components/ui/IconSprite';

export interface SaveButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isSaved?: boolean;
  iconClassName?: string | undefined;
}

export function SaveButton({
  isSaved = false,
  className,
  iconClassName,
  ...props
}: SaveButtonProps) {
  const providedAriaLabel =
    typeof props['aria-label'] === 'string' ? props['aria-label'].trim() : props['aria-label'];
  const ariaLabel = providedAriaLabel || (isSaved ? 'Unsave listing' : 'Save listing');

  return (
    <button
      className={cn(
        'rounded-full px-2 w-8 h-8',
        'bg-trans hover:bg-transparent-hover cursor-pointer',
        className,
      )}
      {...props}
      aria-label={ariaLabel}
    >
      {isSaved ? (
        <SpriteIcon name="heart-filled" className={cn('w-4 h-4', iconClassName)} />
      ) : (
        <SpriteIcon name="heart" className={cn('w-4 h-4 icon-primary', iconClassName)} />
      )}
    </button>
  );
}
